import React from 'react';

import cx from 'classnames';

// import Icon from 'components/shared/Icon';
// import { CalendarSync } from 'components/shared/Icon/icons';
import i18n from 'i18n';

import { Subtitle } from '../../shared/Subtitle';
import s from './index.module.css';

export function Head() {
  return (
    <div className={cx(s.wrapper, 'custom-flights-head-wrapper')}>
      <Subtitle title={i18n.t('proposal_content.guest_portal.flight_and_transfers_page.details')} />

      {/* <div className={s.sync}>
        <div className={s.syncText}>Sync to Calendar</div>
        <Icon component={CalendarSync} className={s.icon} />
      </div> */}
    </div>
  );
}
